import React from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCalendarAlt,
  faChartLine,
  faTimeline,
} from '@fortawesome/free-solid-svg-icons';

const TABS = [
  { key: '#requirements', label: 'Requirements', icon: faCalendarAlt },
  { key: '#timeline', label: 'Timeline', icon: faTimeline },
  { key: '#projection', label: 'Budget', icon: faChartLine },
];

/**
 * Fixed bottom tab bar (portaled so parent transforms do not break position:fixed).
 */
const RequirementsBottomNav = ({ activeTab, onSelect }) => {
  const nav = (
    <nav className="requirements-bottom-nav" role="tablist" aria-label="Requirements sections">
      {TABS.map(({ key, label, icon }) => {
        const active = activeTab === key;
        return (
          <button
            key={key}
            type="button"
            role="tab"
            aria-selected={active}
            className={`requirements-bottom-nav-item${active ? ' is-active' : ''}`}
            onClick={() => onSelect(key)}
          >
            <FontAwesomeIcon icon={icon} className="requirements-bottom-nav-icon" />
            <span className="requirements-bottom-nav-label">{label}</span>
          </button>
        );
      })}
    </nav>
  );

  return createPortal(nav, document.body);
};

RequirementsBottomNav.propTypes = {
  activeTab: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default RequirementsBottomNav;
